import { BaseCommand } from './commands';
import { O2DetailedBarUnbarCommand } from './O2DetailedBarUnbarCommand';

export class O2DetailedBarCommand extends O2DetailedBarUnbarCommand {
  public definitionAlias: 'o2-detailed-bar' = 'o2-detailed-bar';
  constructor(command: BaseCommand) {
    super(command);
  }
}
